import React from 'react';
import {
  Box,
  Container,
  Stack,
  StackProps,
  ContainerProps,
} from '@hover/blueprint';
import { CustomerQuote } from '..';

interface Props extends ContainerProps {
  spacing: StackProps['spacing'];
  description: string;
  customerName: string;
  customerRole: string;
  logo: React.ReactNode;
  imageMaxWidth: string;
  customerImage: React.ReactNode;
}

const CustomerQuoteWithImage: React.FC<Props> = ({
  spacing,
  description,
  customerName,
  customerRole,
  logo,
  imageMaxWidth,
  customerImage,
  ...rest
}) => (
  <Container
    bg="brandTan.200"
    maxW="100%"
    py={{ base: 700, tablet: 1000 }}
    centerContent
    {...rest}
  >
    <Box maxW="1312px" px={{ base: 500, tablet: '56px' }}>
      <Stack
        alignItems="center"
        spacing={spacing}
        direction={{ base: 'column', desktop: 'row' }}
        w="100%"
      >
        <CustomerQuote
          description={description}
          name={customerName}
          customerRole={customerRole}
          logo={logo}
        />
        <Box
          minW={{ base: 'auto', tablet: imageMaxWidth }}
          maxW={imageMaxWidth}
        >
          {customerImage}
        </Box>
      </Stack>
    </Box>
  </Container>
);

export default CustomerQuoteWithImage;
